/* Central icon map — lets modules reference icons by string name. */
import {
  LayoutDashboard, Building2, Sparkles, Target, Users, Radar, PenLine, Image,
  Clapperboard, Megaphone, Stethoscope, Scale, TrendingUp, FileText, Filter,
  Swords, NotebookPen, BookMarked, Library, GraduationCap, BarChart3, Settings,
  LogOut, Menu, Send, Plus, ChevronRight, CircleDollarSign, Save, Pencil,
  ArrowRight, Wrench, type LucideIcon,
} from "lucide-react";

const MAP: Record<string, LucideIcon> = {
  LayoutDashboard, Building2, Sparkles, Target, Users, Radar, PenLine, Image,
  Clapperboard, Megaphone, Stethoscope, Scale, TrendingUp, FileText, Filter,
  Swords, NotebookPen, BookMarked, Library, GraduationCap, BarChart3, Settings,
  LogOut, Menu, Send, Plus, ChevronRight, CircleDollarSign, Save, Pencil,
  ArrowRight, Wrench,
};

export function Icon({ name, size = 20, ...rest }: { name: string; size?: number } & Record<string, unknown>) {
  const C = MAP[name] ?? Sparkles;
  return <C size={size} {...rest} />;
}
